import React, { FC } from 'react';
import { toInterfaceDayFormat } from 'utils/date';
import {
  Container,
  Content,
  MainText,
  SecondaryText,
  Wrap,
  Avatar,
  Text,
  Date,
  // ActionButton,
} from './styles';
import useConnect from './connect';
import { Props } from './types';

const Row: FC<Props> = ({ order, ...props }) => {
  const { goToOrder } = useConnect(order.id);

  return (
    <Container onClick={goToOrder} {...props}>
      <Content>
        <div>
          <MainText>{order.customer.name.displayName}</MainText>
          <SecondaryText>${order.subtotal} Subtotal</SecondaryText>
        </div>
        <Wrap>
          {order.brand.image.src && (
            <Avatar src={order.brand.image.src} alt={order.brand.image.alt} />
          )}
          <Text>{order.brand.name}</Text>
        </Wrap>
        <Wrap>
          <Avatar
            src={order.integration.image.src}
            alt={order.integration.image.alt}
          />
          <div>
            <Text>{order.integration.orderId}</Text>
          </div>
        </Wrap>
        <Wrap>
          <Date>{toInterfaceDayFormat(order.createdAt)}</Date>
        </Wrap>
        {/* <ActionButton variant="print" onClick={handlePrintOrder} /> */}
      </Content>
    </Container>
  );
};

export default Row;
